import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FlowCollectorClass;
function FlowCollector() {
  if (FlowCollectorClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FlowCollector', VOID, VOID, VOID, [1]);
    FlowCollectorClass = $;
  }
  return FlowCollectorClass;
}
//region block: exports
export {
  FlowCollector as FlowCollector26clgpmzihvke,
};
//endregion

//# sourceMappingURL=FlowCollector.mjs.map
